import { Component } from 'react';
import { connect } from 'react-redux';

// Action
import getCovidDonorData from '../../Actions/covidDonorData';


// Component
import Footer from '../Footer';

// Assets
import element from '../../assets/element.svg';
import searchAnimation from '../../assets/searchanimation.gif';

class FindPlasmaDonor extends Component {

    constructor(props) {

        super(props);

        this.state = {

            donorList: null,
            donorAddress: "",
        }
    }

    componentDidMount() {

    
        var data = this.props.donorList;
        this.props.getCovidDonorData();

        if(data != null) {
            this.setState({donorList: this.props.donorList});
        }
    }

    componentDidUpdate() {

        console.log(this.state.donorData)
        if(this.props.donorList != null && this.state.donorList == null) {
            this.setState({donorList: this.props.donorList});
        }
    }

    searchBar(donor) {
    
        if (donor !== undefined) {
          return donor.filter(
            (data) =>
              data.address
                .toLowerCase()
                .indexOf(this.state.donorAddress.toLowerCase()) > -1
          );
        }
    }

    render() {

        return (
            <div className='DonorNearMe'>
                <div className='DonorNearMe_Intro'>
                    <img src={element} />
                    <div className='DonorNearMe_IntroBlock'>
                        <div className='DonorNearMe_Title'>Plasma Donor Mear Me</div>
                        <div className='DonorNearMe_Desc'>
                            This list auto generated list from our donor's Forms collected on this site.  All forms filled up by donor themselves and list generate auto with given information. They are unknown to us. We assume that all information filled by donor is correct and true as they accept such terms and condition. But we cannot confirm you that this information is true. We develop this website for social initiative in todays Covid-19 conditions.
                        </div>
                    </div>
                </div>
                <div className='DonorNearMe_DonorTable'>
                    <div className='DonorNearMe_SearchBarBlock'>
                        <img src={searchAnimation}/>
                        <input className="LiveUpdate_SearchBar" type="search" placeholder="Enter Your Area" onChange={(e) => this.setState({donorAddress: e.target.value})}/>
                    </div>
                    <div className='DonorNearMe_Table'>
                        <table cellSpacing={0} >
                            <tr>
                                <th>Sr No</th>
                                <th>Donor Name</th>
                                <th>Age</th>
                                <th>Contact</th>
                                <th>Blood Group</th>
                                <th>Address</th>
                               {/*} <th>Registration Date</th> */}
                            </tr>
                            {this.state.donorList != null ?
                                this.searchBar(this.state.donorList).map((donor,key) => {
                                 
                                    return(
                                        <tr>
                                            <td>{key+1}</td>
                                            <td>{donor.name}</td>
                                            <td>{donor.age}</td>
                                            <td>{donor.contact}</td>
                                            <td>{donor.bloodGrp}</td>
                                            <td>{donor.address}</td>
                                            {/*<td>0%</td> */}
                                        </tr>
                                    )}
                                )
                                :
                                <tr>
                                    <td>0</td>
                                    <td>name</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0%</td>
                                    {/*<td>0%</td> */}
                                </tr>
                            }
                        </table>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    if(state.donorData != null) {

        return {
            donorList: state.donorData
        };
    }
}

export default connect(mapStateToProps,
    {getCovidDonorData}
)(FindPlasmaDonor);